export default theme => ({
	root: {
		margin: theme.spacing(1),
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		flexWrap: 'wrap',
	},
});
